import InputItemList from '@shared/components/core/field/list/TextInputList';
import { useTranslation } from 'react-i18next';

interface IClientAuthRedirectEditorProps {
    value: string[];
    onUpdate: (field: 'additionalRedirectUris', value: string[]) => void;
}

export default function ClientAuthRedirectEditor({ value, onUpdate }: IClientAuthRedirectEditorProps) {
    const { t } = useTranslation();

    return (
        <InputItemList
            initialValues={value}
            legend={t('common:organization.projects.authRedirect.title')}
            description={t('common:organization.projects.authRedirect.description')}
            onChange={(updatedUris) => onUpdate('additionalRedirectUris', updatedUris)}
        />
    );
}
